/* Source: /tmp/jacbuilder-deploy-scratch/deploy-8asygg26/features/map/Density.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { _jac } from "@jac/prelude";
function aggregate_places(rows, anchors = []) {
  let key;
  let name;
  let group;
  let groups = {};
  for (const row of rows) {
    if ((!Number.isFinite(row["longitude"]) || !Number.isFinite(row["latitude"]))) {
      continue;
    }
    let longitude = row["longitude"];
    let latitude = row["latitude"];
    if (((Math.abs(longitude) > 180) || (Math.abs(latitude) > 90))) {
      continue;
    }
    if (((row["longitude"] === 0) && (row["latitude"] === 0))) {
      continue;
    }
    if ((!Number.isSafeInteger(row["report_count"]) || (row["report_count"] <= 0))) {
      continue;
    }
    key = JSON.stringify([row["longitude"], row["latitude"]]);
    if (!(key in groups)) {
      name = row["name"];
      for (const anchor of anchors) {
        if ((((anchor.geometry.type === "Point") && (anchor.geometry.coordinates[0] === row["longitude"])) && (anchor.geometry.coordinates[1] === row["latitude"]))) {
          name = anchor.properties.label;
        }
      }
      groups[key] = {"key": key, "name": name, "longitude": row["longitude"], "latitude": row["latitude"], "report_count": 0, "missing": 0, "safe": 0, "other": 0, "location_ids": []};
    }
    group = groups[key];
    group["report_count"] = (Math.trunc(Number(group["report_count"])) + Math.trunc(Number(row["report_count"])));
    for (const field of ["missing", "safe", "other"]) {
      if ((Number.isSafeInteger(row[field]) && (row[field] >= 0))) {
        group[field] = (Math.trunc(Number(group[field])) + Math.trunc(Number(row[field])));
      }
    }
    _jac.poly.call(group["location_ids"], "append", row["location_id"]);
  }
  let result = Array.from(Object.values(groups));
  return _jac.builtin.sorted(result, g => {
  return (-Math.trunc(Number(g["report_count"])));
});
}
function density_geojson(groups) {
  return {"type": "FeatureCollection", "features": groups.map(g => ({"type": "Feature", "geometry": {"type": "Point", "coordinates": [g["longitude"], g["latitude"]]}, "properties": {"key": g["key"], "name": g["name"], "report_count": g["report_count"], "missing": g["missing"], "safe": g["safe"], "other": g["other"]}}))};
}
export {aggregate_places, density_geojson};
//# sourceMappingURL=Density.js.map
